<template>
  <v-app :style="cssProps">
    <toolbar :isMainView="isMainView" :isToolEditor="isToolEditor"></toolbar>

    <v-content
      :style="
        isSecondToolbarVisible
          ? 'padding: 112px 0px 0px'
          : 'padding: 64px 0px 0px'
      "
    >
      <v-container fill-height fluid style="align-items: start !important">
        <router-view></router-view>
      </v-container>
    </v-content>

    <toasts></toasts>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import Toolbar from "./components/Toolbar";
import Toasts from "./components/Toasts";

export default {
  name: "App",
  components: {
    Toolbar,
    Toasts,
  },
  data() {
    return {};
  },

  computed: {
    ...mapGetters(["role"]),
    ...mapState([
      "me",
      "riskAnalysisActionsRemaining",
      "mentorshipActionCount",
      "appSettings",
    ]),
    cssProps() {
      return {
        "--primary-color": this.$vuetify.theme.themes.light.primary,
      };
    },
    isMainView() {
      return [
        "profile",
        "employees",
        "employee",
        "external-trainings",
        "instructions",
        "management",
        "mentorship",
        "mentorship-ongoing",
        "mentorship-employee",
        "mentorship-feedback",
        "mentorship-feedback-assigned",
        "mentorship-actions",
        "mentorship-actions-assigned",
        "risk-analysis",
        "risk-analysis-department",
        "risk-analysis-history",
        "single-analysis",
      ].includes(this.$route.name);
    },
    isSecondToolbarVisible() {
      return (
        (this.isMainView &&
          (this.role(
            "manager",
            "departmentManager",
            "admin",
            "safetyRepresentative"
          ) ||
            this.mentorshipActionCount ||
            this.riskAnalysisActionsRemaining !== null)) ||
        this.isToolEditor
      );
    },
    isToolEditor() {
      return (
        this.me &&
        this.me.tags &&
        this.appSettings &&
        this.appSettings.toolEditorTagIds &&
        this.me.tags.some((tag) =>
          this.appSettings.toolEditorTagIds.some((id) => id === tag.id)
        )
      );
    },
  },
  mounted() {
    if (this.me) {
      this.$store.dispatch("update_counts");
    }
  },
};
</script>

<style>
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.02);
}
.table-striped tbody tr {
  height: 56px;
}
.table-striped td {
  border-bottom: none !important;
}
.table-striped .v-data-table-header {
  height: 48px;
}
.safety-elevation-3 {
  box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.05),
    0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12) !important;
}
</style>
